import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpInterceptor,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import { AuthenticationService } from '../_services/authentication.service';
import { AlertService } from '../_services/alert.service';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  constructor(
    private authenticationService: AuthenticationService,
    private alertService: AlertService,
    private router: Router
  ) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    this.alertService.clear();
    // add authorization header with jwt token if available
    let currentUser = this.authenticationService.currentUserValue;
    let currentGroup = this.authenticationService.userGroupsValue;
    if (request.url.includes('/docuedge/workflow')) {
      if (currentUser && currentUser.token) {
        request = request.clone({
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Basic YWRtaW46I1Bhc3N3b3JkQTE=',
            'dw-user': currentUser.username,
            'dw-user-groups': JSON.stringify(currentGroup),
          }),
        });
      }
    } else if (currentUser && currentUser.username.includes('guest')) {
      if (currentUser && currentUser.token) {
        request = request.clone({
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': 'Basic Y2Fsd2F0cnMtZ3Vlc3Q6I1Bhc3N3b3JkQTE='                      
          }),
        });
      }
    } else if (

      !request.url.includes('.blob.core.windows.net/') &&
      !request.url.includes('s3.us-west-1.amazonaws.com/') &&
      !request.url.includes('s3.amazonaws.com/') &&
      !request.url.includes('documents/upload/direct') &&
      !request.url.includes('documents/upload-version/direct') &&                
      !request.url.includes('googleapis.com/') &&
      !request.url.includes('docuedge-workflow') &&
      !request.url.includes('13.58.45.148:8090') &&
      !request.url.includes('mvdiop01rc.execute') &&
      !request.url.includes('rest/server') &&
      !request.url.includes(
        'http://docuedge-dev-performance-alb-404598561.us-east-2.elb.amazonaws.com/'
      ) &&
      !request.url.includes('ps24drplda.execute') &&

      !request.url.includes('redact')
    ) {
      if (currentUser && currentUser.token) {
        request = request.clone({
          headers: new HttpHeaders({

            'Content-Type': 'application/json',            
            'Cache-Control': 'No-Cache',
            'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
            'X-Content-Type-Option':'nosniff',
            'dms-user': currentUser.username,
          }),
        });
      } else {
        request = request.clone({
          headers: new HttpHeaders({                        
            'Cache-Control': 'No-Cache',
            'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
            'X-Content-Type-Option':'nosniff'
          }),
        });
      }
    } else if (
      !request.url.includes('.blob.core.windows.net/') &&
      !request.url.includes('documents/upload/direct') &&
      !request.url.includes('documents/upload-version/direct') &&      
      !request.url.includes('s3.us-west-1.amazonaws.com/') &&
      !request.url.includes('s3.amazonaws.com/') &&
      !request.url.includes('redact') &&
      !request.url.includes('rest/server')
    ) {
      request = request.clone({
        headers: new HttpHeaders({
          'Content-Type': 'application/json'
        }),
      });
    } else if (request.url.includes('redact')) {
      console.log('redact');
      request = request.clone({
        headers: new HttpHeaders({
          Authorization: 'Basic cG5jX2FkbWluOiNQYXNzd29yZEEx',
        }),
      });
    }
    return next.handle(request).pipe(
      catchError((err) => {


        //console.log("inside token error");

        if (err instanceof HttpErrorResponse && err.status === 401) {
          var isDjangoAuth = `${environment.isDjangoAuth}` == 'true';

          var isCognitoAuth = `${environment.isCognitoAuth}` == 'true';


          if (isDjangoAuth) {
            //DJANGO AUTH
            this.authenticationService.logout();
            this.router.navigate(['/login']);

          } else if (isCognitoAuth) {


            //STATE OF FLORIDA
            // this.authenticationService.logout();
            // alert("Please login to the Application")
            // window.close()

            //USE FOR COGNITO AUTH
            return this.authenticationService.refreshToken().pipe(
              switchMap((user: any) => {
                request = request.clone({
                  headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${user.token}`,
                    'dms-user': currentUser.username,
                  }),
                });
                return next.handle(request);
              }),
              catchError((error) => {
                //console.log(error);
                this.authenticationService.logout();
                location.reload();
                return Observable.throw('');
              })
            );
          }
        }
        return Observable.throw(err);
      })
    );
  }
}
